import React, { useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import ReplayIcon from "@mui/icons-material/Replay";
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MobileScreenShareIcon from '@mui/icons-material/MobileScreenShare';

/*
  Props:
    isOpen - boolean
    onClose - function
    onReset - function
*/
export default function Menu({ isOpen, onClose, onReset, setPageValue }) {
  // Prevent page scrolling when modal open
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  const menuItems = [
  {
    icon: <ReplayIcon style={{ width: 35, height: 35 }} />,
    title: "Reset selections",
    type: "full",
      description: "Start fresh",
    onClick: () => {
      if (window.confirm("Are you sure you want to reset all your selections?")) {
        onReset();
      }
    },
    palette: ["#ffe0f2ff", "#fff6f6ff"],
    iconColor: "rgba(255, 86, 170, 0.9)", // neutral gray
  },
  {
    icon: <TravelExploreIcon style={{ width: 35, height: 35 }} />,
    title: "Discovery (Coming Soon)",
    type: "full",
      description: "Explore explainers and interviews",
    onClick: () => { setPageValue(-1); 
      onClose(); 
    // onClick: () => { alert("Discover page coming soon!"); 
      // onClose(); 
    },
    palette: ["#ffdadaff", "#fff6f5ff"],
    iconColor: "#ff6b6bff", // neutral gray
  },
  {
    icon: <InfoOutlinedIcon style={{ width: 35, height: 35 }} />,
    title: "About (Coming Soon)",
    type: "full",
      description: "Find out why we made this",
    onClick: () => { alert("About coming soon!");
      //  onClose(); 
      },
    palette: ["#d3edffff", "#f3f9ffff"],
    iconColor: "#65c1ffff", // neutral gray
  },
  {
    icon: <MobileScreenShareIcon style={{ width: 35, height: 35 }} />,
    title: "Share (Coming Soon)",
    type: "full",
      description: "Share your preferences and results",
    onClick: () => { alert("Sharing coming soon!"); 
      // onClose();
     },
    palette: ["#d0deffff", "#f4f8ffff"],
    iconColor: "#6d99ffff", // neutral gray
  },
];

  return (
    // Always render overlay in DOM so transitions can animate; toggle classes for open/close.
    <div
      className={`menu-overlay ${isOpen ? "open" : "closed"}`}
      onClick={onClose}
    >
      <div className="menu-modal" onClick={(e) => e.stopPropagation()}>
        <div className="menu-grid">
          {menuItems.map((item, i) => (
            <button
          key={i}
  className={`menu-item ${item.type === "full" ? "full" : "half"}`}
              onClick={item.onClick}
              style={{
                color: item.iconColor,
                background: `linear-gradient(180deg, ${item.palette[0]} 0%, ${item.palette[1]} 100%)`,
              }}
            >
              <div className="menu-item-left">
                <div className="menu-icon">{item.icon}</div>
              </div>

              <div className="menu-item-right">
                <h3 className="menu-title">{item.title}</h3>
                <p className="menu-desc">{item.description}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
